import {IconButton, Typography} from '@material-ui/core';
import Dialog, {DialogProps} from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import React, {ReactNode} from 'react';
import './Modal.sass';

type ModalProps = {
  title: React.ReactNode;
  open: boolean;
  children: ReactNode;
  maxWidth?: DialogProps['maxWidth'];
  disableBackdropClick?: boolean;
  className?: string;
  onClose?: () => any;
  hideCloseButton?: boolean;
};

const Modal = (props: ModalProps) => (
  <Dialog
    disableBackdropClick={
      props.disableBackdropClick !== undefined && props.disableBackdropClick !== null
        ? props.disableBackdropClick
        : false
    }
    PaperProps={{
      style: {
        overflow: 'visible',
      },
    }}
    open={props.open}
    onClose={props.onClose}
    disablePortal
    maxWidth={props.maxWidth || 'xl'}
  >
    <div className="modal">
      <div className="modal__header">
        <Typography component="div" className="modal__title">
          {props.title}
        </Typography>
        {!props.hideCloseButton && (
        <div className="modal__close-button-container">
          <IconButton
            id="modal-close-button"
            className="modal__close-button"
            onClick={props.onClose}
            disabled={!props.onClose}
            aria-label={`${props.title} popup close`}
          >
            <CloseIcon />
          </IconButton>
        </div>
        )}
      </div>
      <div className={`modal__body ${props.className || ''}`}>{props.open && props.children}</div>
    </div>
  </Dialog>
);

export default Modal;
